import React, { useState } from 'react';
import { getLang, setLang, SUPPORTED_LANGS } from '../utils/creatorLang';

const LANG_INFO = {
  en: { label: 'English', flag: '🇬🇧' },
  fr: { label: 'Français', flag: '🇫🇷' },
  it: { label: 'Italiano', flag: '🇮🇹' },
  de: { label: 'Deutsch', flag: '🇩🇪' },
};

/**
 * Language selector modal — shown on first creator login.
 * Props: show (bool), onDone (callback after selection)
 */
const LanguageSelector = ({ show, onDone }) => {
  const [selected, setSelected] = useState(getLang());

  if (!show) return null;

  const handleConfirm = () => {
    setLang(selected);
    onDone?.(selected);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100,
      background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
    }}>
      <div style={{
        width: '100%', maxWidth: '360px',
        background: '#111111', border: '1px solid #1f1f1f',
        borderRadius: '16px', padding: '24px',
        fontFamily: 'Inter, sans-serif',
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '40px', height: '40px', borderRadius: '12px', background: 'var(--color-primary)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px',
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </div>
          <h2 style={{ fontSize: '16px', fontWeight: '700', color: 'white', fontFamily: 'var(--font-heading)', margin: '0 0 4px' }}>
            Choose your language
          </h2>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)', margin: 0 }}>
            Choisissez votre langue
          </p>
        </div>

        {/* Language options */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
          {SUPPORTED_LANGS.map((lang) => {
            const info = LANG_INFO[lang];
            const isActive = selected === lang;
            return (
              <button
                key={lang}
                onClick={() => setSelected(lang)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px',
                  padding: '12px 14px', borderRadius: '10px',
                  background: isActive ? 'rgba(229,32,42,0.08)' : 'rgba(255,255,255,0.03)',
                  border: `1px solid ${isActive ? 'rgba(229,32,42,0.4)' : 'rgba(255,255,255,0.08)'}`,
                  cursor: 'pointer', width: '100%', textAlign: 'left',
                  transition: 'all 0.15s ease',
                }}
              >
                <span style={{ fontSize: '22px' }}>{info.flag}</span>
                <span style={{ fontSize: '14px', fontWeight: isActive ? '600' : '400', color: isActive ? 'white' : 'rgba(255,255,255,0.5)' }}>
                  {info.label}
                </span>
                {isActive && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 'auto' }}>
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>

        {/* Confirm */}
        <button
          onClick={handleConfirm}
          style={{
            width: '100%', padding: '12px', borderRadius: '10px',
            background: 'var(--color-primary)', border: 'none',
            color: 'white', fontSize: '14px', fontWeight: '600',
            cursor: 'pointer', fontFamily: 'Inter, sans-serif',
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
